/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AddNoteRequest,
  ApplicationDetail,
  ApplicationSummary,
  DeleteNoteRequest,
  EditNoteRequest,
  ResumeDataResponse,
  SetStatusesRequest,
  SetStatusesResponse,
  UndoStatusesRequest,
} from "../models/index";
import {
  AddNoteRequestFromJSON,
  AddNoteRequestToJSON,
  ApplicationDetailFromJSON,
  ApplicationDetailToJSON,
  ApplicationSummaryFromJSON,
  ApplicationSummaryToJSON,
  DeleteNoteRequestFromJSON,
  DeleteNoteRequestToJSON,
  EditNoteRequestFromJSON,
  EditNoteRequestToJSON,
  ResumeDataResponseFromJSON,
  ResumeDataResponseToJSON,
  SetStatusesRequestFromJSON,
  SetStatusesRequestToJSON,
  SetStatusesResponseFromJSON,
  SetStatusesResponseToJSON,
  UndoStatusesRequestFromJSON,
  UndoStatusesRequestToJSON,
} from "../models/index";

export interface AddApplicationNoteRequest {
  addNoteRequest: AddNoteRequest;
}

export interface DeleteApplicationNoteRequest {
  deleteNoteRequest: DeleteNoteRequest;
}

export interface EditApplicationNoteRequest {
  editNoteRequest: EditNoteRequest;
}

export interface GetApplicationRequest {
  applicationId: string;
}

export interface GetResumeDataRequest {
  key: string;
}

export interface ListApplicationsRequest {
  includeRejected?: boolean;
}

export interface SetApplicationStatusesRequest {
  setStatusesRequest: SetStatusesRequest;
}

export interface UndoApplicationStatusesRequest {
  undoStatusesRequest: UndoStatusesRequest;
}

/**
 *
 */
export class PeopleRecruitingApi extends runtime.BaseAPI {
  /**
   */
  async addApplicationNoteRaw(
    requestParameters: AddApplicationNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["addNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "addNoteRequest",
        'Required parameter "addNoteRequest" was null or undefined when calling addApplicationNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/add-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddNoteRequestToJSON(requestParameters["addNoteRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async addApplicationNote(
    requestParameters: AddApplicationNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.addApplicationNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteApplicationNoteRaw(
    requestParameters: DeleteApplicationNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["deleteNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "deleteNoteRequest",
        'Required parameter "deleteNoteRequest" was null or undefined when calling deleteApplicationNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/delete-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteNoteRequestToJSON(requestParameters["deleteNoteRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteApplicationNote(
    requestParameters: DeleteApplicationNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteApplicationNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editApplicationNoteRaw(
    requestParameters: EditApplicationNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "editNoteRequest",
        'Required parameter "editNoteRequest" was null or undefined when calling editApplicationNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/edit-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditNoteRequestToJSON(requestParameters["editNoteRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editApplicationNote(
    requestParameters: EditApplicationNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editApplicationNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getApplicationRaw(
    requestParameters: GetApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApplicationDetail>> {
    if (requestParameters["applicationId"] == null) {
      throw new runtime.RequiredError(
        "applicationId",
        'Required parameter "applicationId" was null or undefined when calling getApplication().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["applicationId"] != null) {
      queryParameters["applicationId"] = requestParameters["applicationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/get`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApplicationDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getApplication(
    requestParameters: GetApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApplicationDetail> {
    const response = await this.getApplicationRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Resume bytes for Hubble\'s own document viewer. The anonymous /job-application/resume redirect stays for the iframe/download path; this returns the data directly because the viewer renders pages itself and can\'t follow a redirect to a bucket without CORS.
   * Resume bytes for Hubble\'s own document viewer.
   */
  async getResumeDataRaw(
    requestParameters: GetResumeDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResumeDataResponse>> {
    if (requestParameters["key"] == null) {
      throw new runtime.RequiredError(
        "key",
        'Required parameter "key" was null or undefined when calling getResumeData().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["key"] != null) {
      queryParameters["key"] = requestParameters["key"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/resume-data`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResumeDataResponseFromJSON(jsonValue),
    );
  }

  /**
   * Resume bytes for Hubble\'s own document viewer. The anonymous /job-application/resume redirect stays for the iframe/download path; this returns the data directly because the viewer renders pages itself and can\'t follow a redirect to a bucket without CORS.
   * Resume bytes for Hubble\'s own document viewer.
   */
  async getResumeData(
    requestParameters: GetResumeDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResumeDataResponse> {
    const response = await this.getResumeDataRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listApplicationsRaw(
    requestParameters: ListApplicationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ApplicationSummary>>> {
    const queryParameters: any = {};

    if (requestParameters["includeRejected"] != null) {
      queryParameters["includeRejected"] = requestParameters["includeRejected"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ApplicationSummaryFromJSON),
    );
  }

  /**
   */
  async listApplications(
    requestParameters: ListApplicationsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ApplicationSummary>> {
    const response = await this.listApplicationsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async setApplicationStatusesRaw(
    requestParameters: SetApplicationStatusesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SetStatusesResponse>> {
    if (requestParameters["setStatusesRequest"] == null) {
      throw new runtime.RequiredError(
        "setStatusesRequest",
        'Required parameter "setStatusesRequest" was null or undefined when calling setApplicationStatuses().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/set-statuses`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetStatusesRequestToJSON(requestParameters["setStatusesRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SetStatusesResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async setApplicationStatuses(
    requestParameters: SetApplicationStatusesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SetStatusesResponse> {
    const response = await this.setApplicationStatusesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Reverses a /set-statuses: puts the applicants back on their previous status and removes the notes that call created. Backs the undo on the reject toast. The activity log keeps both the rejection and the reversal --- it\'s append-only, so the timeline stays an honest history.
   * Reverses a /set-statuses: puts the applicants back on their previous status and removes the notes that call created.
   */
  async undoApplicationStatusesRaw(
    requestParameters: UndoApplicationStatusesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["undoStatusesRequest"] == null) {
      throw new runtime.RequiredError(
        "undoStatusesRequest",
        'Required parameter "undoStatusesRequest" was null or undefined when calling undoApplicationStatuses().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/recruiting/undo-statuses`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UndoStatusesRequestToJSON(
          requestParameters["undoStatusesRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Reverses a /set-statuses: puts the applicants back on their previous status and removes the notes that call created. Backs the undo on the reject toast. The activity log keeps both the rejection and the reversal --- it\'s append-only, so the timeline stays an honest history.
   * Reverses a /set-statuses: puts the applicants back on their previous status and removes the notes that call created.
   */
  async undoApplicationStatuses(
    requestParameters: UndoApplicationStatusesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.undoApplicationStatusesRaw(requestParameters, initOverrides);
  }
}
